import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import CourseSectionService from "../../../Services/CourseSection.service";
import CourseSectionLookupModal from "./CourseSectionLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => CourseSectionService.search(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => data),
    label: (courseSection) => `[${courseSection.code}] ${courseSection.name} - ${courseSection.section} - ${courseSection.termName}`,
    value: "id",
};
export const CourseSectionSearch = makeSearch(makeSearchArgs);
export const CourseSectionMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { lookupModal: CourseSectionLookupModal }));
